export const FINANCE_ENDPOINT = "/car-loan/";

const USEDFINANCE_CLIENTSIDE_ENDPOINT =
  "/used/stocks/:profileId([ds][0-9]+)/finance/";

export const USED_FINANCE_PAGE_ROUTE = [USEDFINANCE_CLIENTSIDE_ENDPOINT];
